module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2p",
    attrs: {
      "id": "pa01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062059772_Contents#p01"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART I")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2p1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062059772_Contents#p01"
    }
  }, [_vm._v("The Middle East before the Crusades")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "226",
      "src": "images/plates06.jpg",
      "width": "268"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('i', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN THE TURKS EMERGED")]), _vm._v(" from the steppes of Central Asia and captured Baghdad, they became the masters of what had been an Arab empire. The Turks also became the new champions of Islam, the religion brought by the Arabs when they stormed out from the deserts of Arabia to invade and occupy the fertile lands of the Middle East in the seventh century AD, lands that had been part of the Graeco-Roman world for a thousand years and in the case of Palestine had been home to the Jews for twice as long")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('i', [_vm._v("Already since the second millennium BC the Middle East had known the rule of successive rival empires, including the Egyptians, Hittites, Assyrians and Persians. In the early fifth century BC, when the Persians also tried to extend their empire into Europe, they were famously repulsed by the Greeks at Marathon, Salamis and Plataea, and a century and a half later, in 333 BC, when Alexander the Great carried the war into Asia and defeated the Persian king Darius III at the battle of Issus, near the present-day Turkish–Syrian border, the entire Middle East came under the rule and cultural influence of the Greeks. By the end of the first century BC the Greeks in turn had been superseded by the Romans, whose empire embraced all the lands round the Mediterranean. This was the world that gave rise to Christian civilisation")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55b624a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062059772_Part_1.vue
// module id = 75
// module chunks = 0